import { localStorageKeys } from 'storageKeys';

import welcomeImage from 'assets/start-onboarding-unlicenced.png';

import { createTourContext } from '../Tour/createTourContext';

import {
  TOUR_DATASET_ID,
  TOUR_SYSTEM_MODEL,
  TOUR_VERSION,
  UNLICENSED_TOUR_SEARCH_QUERY,
  UNLICENSED_TOUR_STEPS,
} from './constants';

const basePath = `/${TOUR_VERSION}/${TOUR_SYSTEM_MODEL}`;

const {
  useTour: useUnlicensedTour,
  TourProvider: UnlicensedTourProvider,
  Tour: UnlicensedTour,
} = createTourContext({
  name: 'Unlicensed',
  steps: UNLICENSED_TOUR_STEPS,
  storageKey: localStorageKeys.UNLICENSED_TOUR_COMPLETED,
  image: welcomeImage,
  navigateToStep: (navigate, stepIndex, steps) => {
    const step = steps[stepIndex];
    if (!step?.path) return;

    let targetPath: string;

    if (step.path === 'home') {
      targetPath = basePath;
    } else if (step.path === 'search') {
      targetPath = `${basePath}/search?query=${UNLICENSED_TOUR_SEARCH_QUERY}&searchBy=activity`;
    } else if (step.path === 'documentation') {
      targetPath = `${basePath}/dataset/${TOUR_DATASET_ID}/documentation`;
    } else {
      return;
    }

    const currentPathname = window.location.pathname;
    const isOnHomePage = currentPathname === basePath || currentPathname === `${basePath}/`;
    const isOnSearchPage = currentPathname.includes('/search');
    const isOnDocumentationPage = currentPathname.includes('/dataset/');

    const needsNavigation =
      (step.path === 'home' && !isOnHomePage) ||
      (step.path === 'search' && !isOnSearchPage) ||
      (step.path === 'documentation' && !isOnDocumentationPage);

    if (needsNavigation) {
      navigate(targetPath);
    }
  },
  onStartTour: (navigate) => {
    navigate(basePath);
  },
});

export { UnlicensedTourProvider, useUnlicensedTour };
export default UnlicensedTour;
